var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f34235",
    fillRule: "evenodd",
    d: "M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#f34235",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M157 223.5v173.1c0 5.2 4.2 9.4 9.4 9.4h179.3c5.2 0 9.4-4.2 9.4-9.4V204.8h-198v18.7zm195.6-37.4H159.4c-8.9 0-16.1-7.2-16.1-16.1s7.2-16.1 16.1-16.1h61.7v-13c0-19.2 15.6-34.9 34.9-34.9 19.2 0 34.9 15.6 34.9 34.9v13h61.7c8.9 0 16.1 7.2 16.1 16.1s-7.2 16.1-16.1 16.1zm-112.7-32.2h32.2v-13c0-8.9-7.2-16.1-16.1-16.1s-16.1 7.2-16.1 16.1zm68.5 102.8v97.5c0 5.2-4.2 9.4-9.4 9.4s-9.4-4.2-9.4-9.4v-97.5c0-5.2 4.2-9.4 9.4-9.4s9.4 4.2 9.4 9.4zm-43 0v97.5c0 5.2-4.2 9.4-9.4 9.4s-9.4-4.2-9.4-9.4v-97.5c0-5.2 4.2-9.4 9.4-9.4s9.4 4.2 9.4 9.4zm-43.1 0v97.5c0 5.2-4.2 9.4-9.4 9.4s-9.4-4.2-9.4-9.4v-97.5c0-5.2 4.2-9.4 9.4-9.4s9.4 4.2 9.4 9.4z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.5c46e0a74a053ea6fba12f03b0db853d.svg";
export { ForwardRef as ReactComponent };